
 <kendo-textbox-container floatingLabel="Lagerort">
<kendo-dropdownlist [data]="lagerorte" [defaultItem]="{ text: 'Lagerort auswählen', value: 0 }"
[textField]="'text'" [valueField]="'value'" [(ngModel)]="lagerort" [valuePrimitive]="true" (valueChange)="valueChanged($event)"  >
</kendo-dropdownlist>
</kendo-textbox-container>
